import { render, staticRenderFns } from "./switcherBIcon.vue?vue&type=template&id=2272786e&"
import script from "./switcherBIcon.vue?vue&type=script&lang=js&"
export * from "./switcherBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports